import MyAssignmentsPage from './MyAssignmentsPage'
export default MyAssignmentsPage;